module.exports = __webpack_public_path__ + "static/media/homemAvaliacaoDrDiabetes.3c1ea4da.png";